import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { useOnscrollShadow } from '@indriver/whisperwind';
import React__default, { useRef, useEffect } from 'react';
import { Box } from './bottom-sheet-body.styles.js';

var _excluded = ["children"];
var BottomSheetBody = function BottomSheetBody(props) {
  var children = props.children,
      attrs = _objectWithoutPropertiesLoose(props, _excluded);

  var boxRef = useRef(null);

  var _useOnscrollShadow = useOnscrollShadow({
    scrollableRef: boxRef
  }),
      handleScroll = _useOnscrollShadow.handleScroll,
      shadow = _useOnscrollShadow.shadow;

  useEffect(function () {
    handleScroll();
  }, [handleScroll]);
  return /*#__PURE__*/React__default.createElement(Box, _extends({}, attrs, {
    shadow: shadow,
    ref: boxRef,
    onScroll: handleScroll
  }), children);
};

export { BottomSheetBody };
